import { useCssVars as _useCssVars } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-18a51020"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "logo-container"
};
const _hoisted_3 = {
  key: 0,
  class: "logo-title"
};
import SidebarMenu from './SidebarMenu';
import 'vue';
const logoHeight = 44;
export default {
  __name: 'index',
  setup(__props) {
    _useCssVars(_ctx => ({
      "61f54ac0": logoHeight
    }));
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_avatar, {
        size: logoHeight,
        shape: "square",
        src: "/yiyaLogo.png",
        style: {
          "background-color": "transparent"
        }
      }), _ctx.$store.getters.sidebarOpened ? (_openBlock(), _createElementBlock("h1", _hoisted_3, " 博恩口腔一站式智慧辅助诊疗综合服务平台 ")) : _createCommentVNode("", true)]), _createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [_createVNode(_unref(SidebarMenu))]),
        _: 1
      })]);
    };
  }
};